import { render, staticRenderFns } from "./RatingAddTip.vue?vue&type=template&id=375300a4&"
import script from "./RatingAddTip.vue?vue&type=script&lang=js&"
export * from "./RatingAddTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports